module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('TheNavbar'), _vm._v(" "), _c('section', {
    staticClass: "documentation"
  }, [(!_vm.meta.hideSidebar) ? _c('div', {
    staticClass: "sidebar-bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container is-fullhd docs-template-horizontal"
  }, [(!_vm.meta.hideSidebar) ? _c('TheSidebar', {
    attrs: {
      "data": _vm.menu
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "docs-main"
  }, [_c('div', {
    staticClass: "docs-main-container"
  }, [_c('TheHeader', _vm._b({}, 'TheHeader', _vm.meta, false)), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.meta.githubPath) ? [_c('ImproveThis', _vm._b({}, 'ImproveThis', _vm.meta, false))] : _vm._e()], 2)])], 1)]), _vm._v(" "), _c('TheFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e27b688"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/templates/Documentation.vue
// module id = 1604
// module chunks = 300